module.exports = __webpack_public_path__ + "static/media/Hubei Greenhome.63ff8717.webp";